import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetTags as GetTagsQuery,
    GetTagsVariables as GetTagsVariables,
    GetTags_tags as Tags,
} from 'nutshell-graphql-types';

import {GET_TAGS_LIMIT} from '../../../../core/select/hooks/use-get-tags';

import GET_TAGS from '../queries/get-tags.graphql';

export const useGetLeadTags = (): {
    tags: Tags | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
    fetchMore: (searchTerm: string) => Promise<any>;
} => {
    const {
        loading,
        data,
        error,
        refetch,
        fetchMore: fetchMoreTags,
    } = useQuery<GetTagsQuery, GetTagsVariables>(GET_TAGS, {
        variables: {
            input: {
                entityType: 'LEAD',
            },
            // @ts-expect-error
            limit: GET_TAGS_LIMIT,
        },
    });

    return {
        tags: data && data.tags,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
        fetchMore: (searchTerm: string) => {
            // @ts-expect-error
            return fetchMoreTags({
                query: GET_TAGS,
                variables: {
                    limit: GET_TAGS_LIMIT,
                    input: {
                        entityType: 'LEAD',
                        searchTerm: searchTerm,
                    },
                },
                updateQuery: (previousResult, {fetchMoreResult}) => {
                    if (!fetchMoreResult || !previousResult) return;

                    return {
                        tags: {
                            __typename: 'TagsConnection',
                            ...fetchMoreResult.tags,
                        },
                    };
                },
            });
        },
    };
};
